import type { SVGProps } from 'react';

const CopyPlus = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.49835 15.2508C5.53185 15.2508 4.74835 14.4673 4.74835 13.5008V6.75082C4.74835 5.64625 5.64378 4.75082 6.74835 4.75082H13.4984C14.4649 4.75082 15.2484 5.53432 15.2484 6.50082"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2484 8.75082H10.7484C9.64378 8.75082 8.74835 9.64625 8.74835 10.7508V17.2508C8.74835 18.3554 9.64378 19.2508 10.7484 19.2508H17.2484C18.3529 19.2508 19.2484 18.3554 19.2484 17.2508V10.7508C19.2484 9.64625 18.3529 8.75082 17.2484 8.75082Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9984 11.3967V16.605"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6025 14.0008H11.3942"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopyPlus;
